import {
  Balance,
  List,
  ListItem,
  SuitabilityBadge,
  Text,
  Tooltip,
  VStack,
} from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerWalletPoints } from '../../../../../components/CustomerWalletPoints';
import { mountAccount } from '../../../../../store/customer/normalize';
import { CustomerItemSelectedProps } from '../models';
import { IconCustomerList } from '../TableItem/components/IconCustomerList';

export const DesktopCustomerItemSelected: React.FC<CustomerItemSelectedProps> = (props) => {
  const custodyAccount = mountAccount(
    props.customerItem.pnpAccountNumber,
    props.customerItem.pnpAccountDigit
  );
  return (
    <List testId="selected-customer" height={115}>
      <ListItem testId="selected-customer-name" title="Nome">
        <Tooltip testId="qa" label={props.customerItem.name || ''}>
          <VStack>
            <Text
              testID="product-display-data-selected"
              lineHeight={'medium'}
              mb={Spacing['inline.nano']}>
              {props.customerItem.name}
            </Text>
          </VStack>
        </Tooltip>
        {props.customerCaption?.length > 0 && <IconCustomerList icons={props.customerCaption} />}
      </ListItem>
      <ListItem testId="selected-customer-account-number" title="Conta de Custódia">
        {custodyAccount}
      </ListItem>
      <ListItem testId="selected-customer-risco" title="Suitability">
        <SuitabilityBadge label={props.customerItem.suitabilityProfileName || ''} />
      </ListItem>
      <ListItem testId="selected-customer-risco" title="Pts na carteira">
        <CustomerWalletPoints accountNumber={props.customerItem.accountNumber} />
      </ListItem>
      <ListItem testId="selected-customer-registration-status-name" title="Situação cadastral">
        {props.customerItem.registrationStatusName}
      </ListItem>
      <ListItem testId="selected-customer-available-balance" title="Saldo disponível">
        <Balance
          testId="selected-customer-available-balance"
          value={props.customerItem.availableBalance}
          isLoading={props.isLoadingBalance}
          onUpdate={() => props.handleUpdateBalance(props.customerItem)}
        />
      </ListItem>
      <VStack alignItems={'flex-end'} w={'130px'}>
        <Text lineHeight="distant" fontSize={Typography['fontsize.md']} variant="semibold">
          Saldo estimado
        </Text>
        <Box alignItems={'flex-end'}>
          <Text
            lineHeight="distant"
            fontSize={Typography['fontsize.md']}
            variant="regular"
            numberOfLines={1}
            {...(props.estimatedValue.startsWith('-') && { color: 'feedback.error.default' })}>
            {props.estimatedValue}
          </Text>
          <Text
            color="neutral.light"
            lineHeight="medium"
            fontSize={Typography['fontsize.xs']}
            variant="regular">
            Após investimento
          </Text>
        </Box>
      </VStack>
    </List>
  );
};
